import View from './view';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../../redux/selectors/resources';
import {surveysListSelector} from '../../../redux/selectors/polls';
import {usePartialList} from '../../../shared/hooks/usePartialList';
import {PollStatus} from '../../../shared/models/poll';
import {useMemo} from 'react';

export const PollsTypeSurveyScreen = () => {
  const content = useSelector(contentSelector());
  const polls = useSelector(surveysListSelector());

  const isLoading = !polls;
  const completedVotes =
    useMemo(() => polls?.filter((item) => item.statusId === PollStatus.Completed), [polls]) || null;
  const notCompletedVotes =
    useMemo(() => polls?.filter((item) => item.statusId !== PollStatus.Completed), [polls]) || null;

  const [completedItemsToShow, showMoreCompleted, allCompletedShown] = usePartialList(completedVotes);

  const [notCompletedItemsToShow, showMoreNotCompleted, allNotCompletedShown] = usePartialList(notCompletedVotes);

  return View({
    content,
    isLoading,
    pollGroups: [
      {
        showLoadMore: !allNotCompletedShown,
        polls: notCompletedItemsToShow,
        title: 'Текущие опросы',
        onLoadMore: showMoreNotCompleted,
        noItemsText: content.polls.noActiveSurveys,
      },
      {
        showLoadMore: !allCompletedShown,
        polls: completedItemsToShow,
        title: 'Завершенные опросы',
        onLoadMore: showMoreCompleted,
        noItemsText: content.polls.noCompletedSurveys,
      },
    ],
  });
};
